import Form from '../Page/Form';

export default Form;
